export default __webpack_public_path__ + "static/media/FFT_of_smlmIllustration.70928f0c.png";